import cloneDeep from 'lodash/cloneDeep';
import omit from 'lodash/omit';
import * as actionTypes from '../action-types';
import { WatchersActions } from '../actions';
import { WatcherCount, WatcherTotalEnum } from '../../watchers.types';
import { initEmptyWatcherCounts } from '../../WatchersUtils';

type Reducer = {
  [key: string]: Array<WatcherCount>;
};

const defaultState: Reducer = {};

export function watchersCountsMapReducer(
  state: Reducer = defaultState,
  action: WatchersActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHER: {
      const { watcher } = action.payload;
      return {
        ...cloneDeep(state),
        [watcher.key]: initEmptyWatcherCounts(watcher),
      };
    }
    case actionTypes.SET_WATCHER_WITH_COUNTS: {
      const { watcher } = action.payload;
      return {
        ...cloneDeep(state),
        [watcher.key]: watcher.counts.documents,
      };
    }
    case actionTypes.SET_WATCHERS: {
      const { watchers } = action.payload;
      return watchers.reduce((acc: Reducer, watcher) => {
        acc[watcher.key] = watcher.counts.documents;
        return acc;
      }, {});
    }
    case actionTypes.CREATE_WATCHER: {
      const { watcher } = action.payload;
      return {
        ...cloneDeep(state),
        [watcher.key]: initEmptyWatcherCounts(watcher),
      };
    }
    case actionTypes.DELETE_WATCHER: {
      const { watcherKey } = action.payload;
      return omit({ ...cloneDeep(state) }, watcherKey);
    }
    case actionTypes.SET_DOCUMENT_AS_READ: {
      const { watcherKey, documentType } = action.payload;
      if (state[watcherKey]) {
        const newCount = state[watcherKey].map((count) => {
          if (
            count.type === WatcherTotalEnum.TOTAL ||
            count.type === documentType
          ) {
            return {
              ...count,
              read: count.read + 1,
              notRead: count.notRead - 1,
            };
          }
          return count;
        });

        return { ...cloneDeep(state), [watcherKey]: newCount };
      }
      return state;
    }
    case actionTypes.SET_ALL_DOCUMENTS_AS_READ: {
      const { watcherKey } = action.payload;
      if (state[watcherKey]) {
        const newCount = state[watcherKey].map((count) => {
          return { ...count, read: count.total, notRead: 0 };
        });

        return { ...cloneDeep(state), [watcherKey]: newCount };
      }
      return state;
    }
    case actionTypes.DELETE_WATCHER_QUERY: {
      const { watcherKey, type } = action.payload;
      return state[watcherKey]
        ? {
            ...cloneDeep(state),
            [watcherKey]: state[watcherKey].filter(
              (count) => count.type !== type,
            ),
          }
        : state;
    }
    default: {
      return state;
    }
  }
}
